import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { useBanners } from "../../../../contexts";
import { CarouselDot } from "../../../../components";
import * as s from "./styles";

const BannersCrousel = () => {
  const { banners, openBannerDetails, autoPlayBannersCarosel } = useBanners();

  const CustomDot = (props: any) => {
    return <CarouselDot active={props.active} />;
  };

  return (
    <Carousel
      additionalTransfrom={0}
      arrows={false}
      autoPlay={autoPlayBannersCarosel}
      autoPlaySpeed={4000}
      centerMode={false}
      className=""
      containerClass="container"
      dotListClass=""
      draggable
      focusOnSelect={false}
      infinite
      itemClass=""
      minimumTouchDrag={80}
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
        },
      }}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots
      sliderClass=""
      slidesToSlide={1}
      swipeable
      customDot={<CustomDot />}
    >
      {banners.map((banner) => (
        <s.Banner
          onClick={() => openBannerDetails(banner)}
          className="background-image"
          key={banner.bannerId}
          src={banner.imageUrl}
        />
      ))}
    </Carousel>
  );
};

export default BannersCrousel;
